<template>
  <div id="container"></div>
</template>
<script>
import * as Three from "three";
import { TWEEN } from "three/examples/jsm/libs/tween.module.min";
// import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

// import { VertexNormalsHelper } from "three/examples/jsm/helpers/VertexNormalsHelper.js";
// import { VertexTangentsHelper } from "three/examples/jsm/helpers/VertexTangentsHelper.js";

export default {
  name: "FondoIntro",
  data() {
    return {
      cono: null,
      mostrarTexto1: true,
      mostrarTexto2: false,
      mostrarTexto3: false,
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      gridHelper: null,
      rotar: false,
      tween1: null,
      tween2: null,
      transparente: null,
      modelo: null,
      loader: null,
      group: null,
      torusKnot: null,
      line: null,
    };
  },
  props: { siguiente: Number, anterior: Number },
  methods: {
    init: function () {
      let container = document.getElementById("container");
      this.camera = new Three.PerspectiveCamera(
        45,
        container.clientWidth / container.clientHeight,
        0.01,
        2000
      );
      this.camera.position.z = 16;
      this.scene = new Three.Scene();
      this.scene.rotation.x = Math.PI / 2;
      this.scene.rotation.y = -Math.PI;
      const spotLight = new Three.SpotLight(0xffffff, 0.7);
      spotLight.position.set(-10, 2, 10);

      const targetObject = new Three.Object3D();
      targetObject.position.set(-15, 5, 1);
      this.scene.add(targetObject);

      spotLight.target = targetObject;

      this.scene.add(spotLight.target);
      this.scene.add(spotLight);

      let geometry = new Three.BoxGeometry(1, 1, 1);
      let material = new Three.MeshNormalMaterial({
        // color: 0x0000ff,
        transparent: true,
        opacity: 1.0,
      });
      let material2 = new Three.MeshNormalMaterial({
        // color: 0x0000ff,
        transparent: true,
        opacity: 1.0,
      });
      // let material3 = new Three.MeshNormalMaterial({
      //   // color: 0x0000ff,
      //   transparent: true,
      //   opacity: 1.0,
      // });
      this.mesh = new Three.Mesh(geometry, material);
      this.mesh.position.y = 1.5;
      this.mesh.position.x = -14.3;
      this.mesh.position.z = 6.7;

      this.scene.add(this.mesh);

      const torusKnotGeo = new Three.TorusKnotGeometry(1, 0.3, 100, 16);
      // const material = new Three.MeshBasicMaterial({ color: 0xffff00 });
      this.torusKnot = new Three.Mesh(torusKnotGeo, material2);
      this.torusKnot.position.y = 4.5;
      this.torusKnot.position.x = -8.3;
      this.torusKnot.position.z = -5.7;
      this.scene.add(this.torusKnot);
      const light = new Three.PointLight();
      light.position.set(200, 100, 150);
      this.scene.add(light);

      this.scene.add(new Three.PointLightHelper(light, 15));
      this.loader = new GLTFLoader();
      this.loader.load("/models/LeePerrySmith.glb", (glb) => {
        this.modelo = glb.scene.children[0];
        console.log(this.modelo);

        // this.modelo.geometry.computeTangents(); // generates bad data due to degenerate UVs

        this.group = new Three.Group();
        this.group.scale.multiplyScalar(0.8);
        this.scene.add(this.group);

        // To make sure that the matrixWorld is up to date for the boxhelpers
        this.group.updateMatrixWorld(true);

        const materialWireframe = new Three.LineBasicMaterial({
          color: 0x0000ff,
          linewidth: 1,
          opacity: 0.45,
          linecap: "round", //ignored by WebGLRenderer
          linejoin: "round", //ignored by WebGLRenderer
        });
        // this.group.add(this.modelo);
        this.group.position.y = 1.5;
        this.group.position.x = 14.3;
        this.group.position.z = 2.7;
        const wireframe = new Three.WireframeGeometry(this.modelo.geometry);
        this.line = new Three.LineSegments(wireframe, materialWireframe);
        this.line.material.depthTest = true;
        // this.line.material.opacity = 0.45;
        this.line.material.transparent = true;
        // this.line.position.x = 4;
        this.group.add(this.line);
        // const boxHelper = new Three.BoxHelper(this.modelo);
        // this.group.add(boxHelper);
      }),
        (xhr) => {
          console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
        },
        (error) => {
          console.error(error);
        };

      const GeoCono = new Three.ConeGeometry(0.5, 1, 32);
      const geoCil = new Three.CylinderGeometry(0.5, 0.5, 1, 32);

      const cylinder2 = new Three.Mesh(geoCil, material);
      const cubo = new Three.Mesh(geometry, material);
      this.cono = new Three.Mesh(GeoCono, material);

      cubo.position.y = 4.5;
      cubo.position.x = 8.5;
      cubo.position.z = -5.7;

      cylinder2.position.y = 3;
      cylinder2.position.x = 9.3;
      cylinder2.position.z = -3.7;

      this.cono.position.y = 3.5;
      this.cono.position.x = 7.3;
      this.cono.position.z = -4;

      cubo.scale.set(1.5, 1.5, 1.5);
      this.cono.scale.set(1.5, 1.5, 1.5);
      cylinder2.scale.set(1.5, 1.5, 1.5);

      this.scene.add(cubo);
      this.scene.add(this.cono);
      this.scene.add(cylinder2);

      const size = 50;
      const divisions = 50;

      this.gridHelper = new Three.GridHelper(size, divisions);
      //   this.gridHel   per.rotation.x = Math.PI / 2;
      this.scene.add(this.gridHelper);

      const moverRotaciones1 = new TWEEN.Tween(this.cono.rotation)
        .to({ x: Math.PI / 2 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotaciones2.start();
        });
      const moverRotaciones2 = new TWEEN.Tween(this.cono.rotation)
        .to({ x: Math.PI }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotaciones1.start();
        });
      moverRotaciones2.start();

      const moverRotacionesCubo1 = new TWEEN.Tween(cubo.rotation)
        .to({ y: Math.PI / 2, x: -Math.PI }, 2000)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotacionesCubo2.start();
        });
      const moverRotacionesCubo2 = new TWEEN.Tween(cubo.rotation)
        .to({ y: Math.PI, x: Math.PI / 2 }, 2000)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotacionesCubo1.start();
        });
      moverRotacionesCubo1.start();

      const moverRotacionesCyli1 = new TWEEN.Tween(cylinder2.rotation)
        .to({ x: Math.PI / 2, z: -Math.PI }, 2250)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotacionesCyli2.start();
        });
      const moverRotacionesCyli2 = new TWEEN.Tween(cylinder2.rotation)
        .to({ x: Math.PI, z: Math.PI / 2 }, 2250)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotacionesCyli1.start();
        });
      moverRotacionesCyli1.start();

      this.tween1 = new TWEEN.Tween(this.scene.rotation)
        .to({ x: 0.2, y: 0 }, 6000)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {});

      this.tween2 = new TWEEN.Tween(this.scene.position)
        .to({ z: -12 }, 6000) //6000
        .easing(TWEEN.Easing.Cubic.InOut);

      const moverTorus1 = new TWEEN.Tween(this.torusKnot.scale)
        .to({ x: 1.5, y: 1.5, z: 1.5 }, 3500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus2.start();
        });
      const moverTorus2 = new TWEEN.Tween(this.torusKnot.scale)
        .to({ x: 1, y: 1, z: 1 }, 3500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus3.start();
        });
      const moverTorus3 = new TWEEN.Tween(this.torusKnot.position)
        .to({ y: 7.5 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus4.start();
        });
      const moverTorus4 = new TWEEN.Tween(this.torusKnot.position)
        .to({ y: 3.5 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus5.start();
        });
      const moverTorus5 = new TWEEN.Tween(this.torusKnot.rotation)
        .to({ x: Math.PI / 2, y: Math.PI / 2, z: Math.PI / 2 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus6.start();
        });
      const moverTorus6 = new TWEEN.Tween(this.torusKnot.rotation)
        .to({ x: Math.PI, y: Math.PI, z: Math.PI }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus1.start();
        });
      moverTorus1.start();

      const moverCubo1 = new TWEEN.Tween(this.mesh.position)
        .to({ x: -14.3 + 2 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverCubo2.start();
        });
      const moverCubo2 = new TWEEN.Tween(this.mesh.position)
        .to({ x: -14.3 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverCubo3.start();
        });
      const moverCubo3 = new TWEEN.Tween(this.mesh.position)
        .to({ y: 3.5 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverCubo4.start();
        });
      const moverCubo4 = new TWEEN.Tween(this.mesh.position)
        .to({ y: 1.5 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverCubo1.start();
        });
      moverCubo1.start();
      this.transparente = new Three.MeshLambertMaterial({
        color: 0x0000ff,
        transparent: true,
        opacity: 0.0,
      });

      let maxX = 2;
      let axisXLength = maxX * 2;
      const axisXHeadLength = axisXLength * 0.25;
      const axisXHeadWidth = axisXHeadLength * 1;
      const directionX = new Three.Vector3(1, 0, 0);
      const startX = new Three.Vector3(-maxX, 0, 0);
      const colorX = 0xff0000;
      const axisX = new Three.ArrowHelper(
        directionX,
        startX,
        axisXLength + axisXHeadLength * 2,
        colorX,
        axisXHeadLength,
        axisXHeadWidth
      );
      axisX.position.x = -15;
      axisX.position.y = 1;
      axisX.position.z = 6;

      const geometryX = new Three.CylinderGeometry(0.15, 0.15, 5, 32);
      const materialX = new Three.MeshPhongMaterial({ color: colorX });
      const cylinder = new Three.Mesh(geometryX, materialX);
      cylinder.rotation.z = Math.PI / 2;
      cylinder.position.x = -12.5;
      cylinder.position.y = 1;
      cylinder.position.z = 6;
      this.scene.add(cylinder);

      this.scene.add(axisX);

      let axisYLength = maxX * 2;
      const axisYHeadLength = axisYLength * 0.25;
      const axisYHeadWidth = axisYHeadLength;
      const directionY = new Three.Vector3(0, 1, 0);
      const startY = new Three.Vector3(0, maxX, 0);
      const colorY = 0x00ff00;
      const axisY = new Three.ArrowHelper(
        directionY,
        startY,
        axisYLength + axisYHeadLength * 2,
        colorY,
        axisYHeadLength,
        axisYHeadWidth
      );
      axisY.position.x = -15;
      axisY.position.y = 1;
      axisY.position.z = 6;

      const materialY = new Three.MeshPhongMaterial({ color: colorY });
      const cylinderY = new Three.Mesh(geometryX, materialY);
      cylinderY.rotation.y = Math.PI / 2;
      cylinderY.position.x = -15;
      cylinderY.position.y = 3.5;
      cylinderY.position.z = 6;
      this.scene.add(cylinderY);
      this.scene.add(axisY);

      let axisZLength = maxX * 2;
      const axisZHeadLength = axisZLength * 0.25;
      const axisZHeadWidth = axisZHeadLength;
      const directionZ = new Three.Vector3(0, 0, 1);
      const startZ = new Three.Vector3(0, 0, maxX);
      const colorZ = 0x0000ff;
      const axisZ = new Three.ArrowHelper(
        directionZ,
        startZ,
        axisZLength + axisZHeadLength * 2,
        colorZ,
        axisZHeadLength,
        axisZHeadWidth
      );
      axisZ.position.x = -15;
      axisZ.position.y = 1;
      axisZ.position.z = 6;

      const materialZ = new Three.MeshPhongMaterial({ color: colorZ });
      const cylinderZ = new Three.Mesh(geometryX, materialZ);
      cylinderZ.rotation.x = Math.PI / 2;
      cylinderZ.position.x = -15;
      cylinderZ.position.y = 1;
      cylinderZ.position.z = 3.5 + 5;
      this.scene.add(cylinderZ);

      this.scene.add(axisZ);

      this.renderer = new Three.WebGLRenderer({ antialias: true });
      this.renderer.setSize(container.clientWidth, container.clientHeight);
      container.appendChild(this.renderer.domElement);
      // this.controls = new OrbitControls(this.camera, this.renderer.domElement);

      //controls.update() must be called after any manual changes to the camera's transform
      //   this.camera.position.set(0, 20, 100);
      //   this.controls.update();
    },
    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();

      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    animate: function () {
      if (
        this.$router.history.current.path == "/home" ||
        this.$router.history.current.path == "/menu"
      ) {
        window.addEventListener("resize", this.onWindowResize);
        if (this.modelo) {
          this.group.rotation.y += 0.009;
        }
        requestAnimationFrame(this.animate);
        TWEEN.update();
        this.renderer.render(this.scene, this.camera);
      }
    },

    mirar: function () {
      console.log("p camera:", this.camera.position);
      console.log("p scena:", this.scene.position);
      console.log("r camera:", this.camera.rotation);
      console.log("r scena:", this.scene.rotation);
    },
    siguienteModulo: function (cont) {
      if (cont == 1) {
        new TWEEN.Tween(this.torusKnot.material)
          .to({ opacity: 1 }, 1500)
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();
        let tween = new TWEEN.Tween(this.camera.position)
          .to(
            {
              x: -9.318957274643072,
              y: 2.2,
              z: 2,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut);
        tween.start();
        new TWEEN.Tween(this.scene.position)
          .to(
            {
              x: -8.3,
              y: -2.5,
              z: -5.7,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();
        new TWEEN.Tween(this.camera.rotation)
          .to(
            {
              x: 0,
              y: 0,
              z: 0,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();
        new TWEEN.Tween(this.scene.rotation)
          .to(
            {
              x: 0,
              y: -0.15707963267948966,
              z: 0,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();
      } else if (cont == 2) {
        let tween = new TWEEN.Tween(this.camera.position)
          .to(
            {
              x: 1,
              y: 2.2,
              z: 2,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut);
        tween.start();
        new TWEEN.Tween(this.scene.position)
          .to(
            {
              x: -8.3,
              y: -2.5,
              z: -5.7,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();
        new TWEEN.Tween(this.camera.rotation)
          .to(
            {
              x: 0,
              y: 0,
              z: 0,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();
        new TWEEN.Tween(this.scene.rotation)
          .to(
            {
              x: 0.2,
              y: 0.3141592653589793,
              z: 0,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();
        new TWEEN.Tween(this.line.material)
          .to(
            {
              opacity: 0,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();
      } else if (cont == 3) {
        let tween = new TWEEN.Tween(this.camera.position)
          .to(
            {
              x: 1,
              y: 2.2,
              z: 0,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut);
        tween.start();
        new TWEEN.Tween(this.scene.position)
          .to(
            {
              x: -8.3,
              y: -2.5,
              z: -5.7,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();
        new TWEEN.Tween(this.camera.rotation)
          .to(
            {
              x: 0,
              y: 0,
              z: 0,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();
        new TWEEN.Tween(this.scene.rotation)
          .to(
            {
              x: 0.2,
              y: 1.5707963267948966,
              z: 0,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();
        new TWEEN.Tween(this.line.material)
          .to(
            {
              opacity: 0.45,
            },
            1500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();
        new TWEEN.Tween(this.cono.material).to(
          {
            opacity: 1,
          },
          1500
        );
      } else {
        let tween = new TWEEN.Tween(this.camera.position)
          .to(
            {
              x: -9.307818982728334,
              y: 2.2,
              z: 2,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut);
        tween.start();
        let tween2 = new TWEEN.Tween(this.scene.position)
          .to(
            {
              x: -2,
              y: -2.5,
              z: -5,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut);
        tween2.start();

        new TWEEN.Tween(this.camera.rotation)
          .to(
            {
              x: 0,
              y: 0,
              z: 0,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();

        new TWEEN.Tween(this.scene.rotation)
          .to(
            {
              x: 0.2,
              y: -1.0471975511965976,
              z: 0,
            },
            3500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();
        new TWEEN.Tween(this.cono.material)
          .to(
            {
              opacity: 1,
            },
            1500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();

        new TWEEN.Tween(this.torusKnot.material)
          .to(
            {
              opacity: 0,
            },
            1500
          )
          .easing(TWEEN.Easing.Cubic.InOut)
          .start();
      }
    },
  },
  mounted() {
    this.init();
    this.animate();
    // setTimeout(() => {
    // this.tween1.start();
    // this.tween2.start();
    // }, 10000);
  },
  watch: {
    siguiente(nuevoValor, valorAnterior) {
      console.log(
        "El siguiente pasó de ser '%s' a '%s'",
        valorAnterior,
        nuevoValor
      );

      this.siguienteModulo(nuevoValor);
    },
    anterior(nuevoValor, valorAnterior) {
      console.log(
        "El anterior pasó de ser '%s' a '%s'",
        valorAnterior,
        nuevoValor
      );

      this.siguienteModulo(nuevoValor);
    },
  },
};
</script>
<style scoped>
#container {
  height: 100vh;
  width: 100vw;
}
</style>
